import Vue from "vue";
import Vuetify from "vuetify/lib";
import { extend, wpComponents, vuetifyComponents } from "../components";
import ru from "vuetify/src/locale/ru";
import colors from "vuetify/lib/util/colors";
import { Resize, Scroll } from "vuetify/lib/directives";

const allComponents = extend(wpComponents, vuetifyComponents);

Vue.use(Vuetify, { components: allComponents, directives: { Resize, Scroll } });

export default new Vuetify({
  lang: {
    locales: { ru },
    current: "ru",
  },
  theme: {
    themes: {
      light: {
        primary: "#000000",
        accent: "#295f92",
        secondary: "#031b30",
        info: colors.teal.lighten1,
        warning: colors.amber.base,
        error: colors.deepOrange.accent4,
        success: colors.green.accent3,
        background: "#aa3737"
      }
    }
  },
});
